var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0931 38.2901C77.0525 55.0737 65.8458 71.0785 49.0622 74.0379L21.6927 78.8638C19.0078 79.3373 17.086 76.301 18.647 74.0518L23.5368 67.0061C18.3406 62.525 14.5989 56.2913 13.3145 49.007C10.3551 32.2235 21.5618 16.2187 38.3453 13.2593C55.1289 10.2999 71.1337 21.5066 74.0931 38.2901ZM54.2766 37.7331C55.2541 36.3371 54.9149 34.4129 53.5188 33.4354C52.1228 32.4579 50.1987 32.7972 49.2211 34.1932L40.9788 45.9646L36.357 42.7284C34.9609 41.7508 33.0368 42.0901 32.0593 43.4862C31.0817 44.8822 31.421 46.8063 32.8171 47.7839L39.9666 52.79C40.637 53.2594 41.4664 53.4433 42.2724 53.3012C43.0784 53.1591 43.7949 52.7026 44.2643 52.0322L54.2766 37.7331Z",
    fill: "#31C440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.dcd729d991dd04e767653bce15f31701.svg";
export { ForwardRef as ReactComponent };